import {
  AmazonOutlined,
  AuditOutlined,
  BankOutlined,
  BellOutlined,
  CalculatorOutlined,
  CarFilled,
  CiOutlined,
  CoffeeOutlined,
  DatabaseFilled,
  DollarOutlined,
  EuroCircleOutlined,
  ExportOutlined,
  FileProtectOutlined,
  FormOutlined,
  FundOutlined,
  GlobalOutlined,
  MailOutlined,
  MinusCircleOutlined,
  MoneyCollectOutlined,
  MonitorOutlined,
  PieChartOutlined,
  RestOutlined,
  RetweetOutlined,
  RobotOutlined,
  KeyOutlined,
  SettingOutlined,
  ShopOutlined,
  SmileFilled,
  StarFilled,
  SwapOutlined,
  TagOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  LineChartOutlined,
  UndoOutlined,
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { fetchAPI } from '../../utils/api';

import { LOGO, USER_ROLES, USER_TEAMS } from '../../constants/CONSTANTS';
import * as URLS from '../../constants/URLS';
import CartDrawer from '../../containers/Cart/CartDrawer';
import useWindowDimension from '../../utils/useWindowDimension';
import Page403 from '../ErrorPage/Page403';
import ReportLabel from '../ReportLabel';
import DashboardHeader from './DashboardHeader';

const {
  URL_ANALYTICS,
  URL_ENTITY,
  URL_ASYNC_TASK_REPORT,
  URL_API_KEYS,
  URL_API_KEY_ANALYTICS,
  URL_PERMISSION_GROUPS,
  URL_OVERVIEW,
  URL_PO,
  URL_PO_V2,
  URL_PRODUCT_CODE,
  URL_QUOTATIONS,
  URL_RESOURCE,
  URL_RESOURCE_STORE,
  URL_RFQ,
  URL_SETTINGS,
  URL_EXCHANGE_RATE_SETTINGS,
  URL_SUPPLIER_PAYMENTS_GRAPHS,
  URL_SUPPLIER_PAYMENTS,
  URL_PAYMENT_METHODS,
  URL_OCI,
  URL_SUPPLIER_PAYMENTS_V2,
  URL_REVERT_SUPPLIER_PAYMENT_STATUS,
  URL_SOA_PAYMENTS,
  URL_BILLING_PARTIES,
  URL_SUPPLIERS,
  URL_USERS,
  URL_XERO_SETTINGS,
  URL_SYNC_99SME,
  URL_JD_INTEGRATION,
  URL_MONTHLY_ANALYTICS,
  URL_SUPPLIER_SOA,
  URL_CUSTOMER_SOA,
  URL_CUSTOMER_SOA_CONSOLIDATED_LIST,
  URL_DELETE_PRODUCT,
  URL_EMAIL_READER_ORDER_FROM_MAIL,
  URL_PRODUCT_EXTERNAL,
  URL_TICKETING_LIST,
  URL_GRN_RATING_LIST,
  URL_PRODUCT,
  URL_PRODUCT_MARKETPLACE,
  URL_S2P_PERSONAL_DASHBOARD,
  URL_SME_MARKETPLACE,
  URL_PETER_NCPR_MARKETPLACE,
  URL_LINE_ITEM_ANALYTIC,
  URL_BUYER_INVOICING,
  URL_CRON_TRIGGERS,
  URL_NOTIFICATIONS,
} = URLS;
const { Content, Sider } = Layout;

type Props = {
  children: React.ReactNode;
};
export const menuItems = [
  {
    key: URL_TICKETING_LIST,
    icon: <TagOutlined />,
    title: 'RFI Tickets',
  },
  {
    key: URL_SME_MARKETPLACE,
    icon: <ShopOutlined />,
    title: 'SME Marketplace',
  },
  {
    key: URL_S2P_PERSONAL_DASHBOARD,
    icon: <SmileFilled />,
    title: 'Personal Dashboard',
  },
  {
    key: URL_PRODUCT,
    icon: <CoffeeOutlined />,
    title: 'Product Listing',
  },
  {
    key: URL_PRODUCT_MARKETPLACE,
    icon: <CoffeeOutlined />,
    title: 'Product Marketplace',
  },
  {
    key: URL_PETER_NCPR_MARKETPLACE,
    icon: <RobotOutlined />,
    title: 'Peter NCPR Marketplace',
  },
  {
    key: URL_OVERVIEW,
    icon: <PieChartOutlined />,
    title: 'Product Overview',
  },
  {
    key: 'analytic-submenu',
    icon: <LineChartOutlined />,
    title: 'Analytic',
    children: [
      {
        key: URL_ANALYTICS,
        icon: <FundOutlined />,
        title: 'Legacy',
      },
      {
        key: URL_SUPPLIER_PAYMENTS_GRAPHS,
        icon: <MoneyCollectOutlined />,
        title: 'Supplier Payments',
      },
      {
        key: URL_LINE_ITEM_ANALYTIC,
        icon: <LineChartOutlined />,
        title: 'Line Items',
      },
    ],
  },
  {
    key: URLS.URL_ASYNC_TASK_REPORT,
    icon: <DatabaseFilled />,
    title: <ReportLabel />,
  },
  {
    key: URL_PO,
    icon: <ExportOutlined />,
    title: 'Order',
  },
  {
    key: URLS.URL_PO_V2,
    icon: <ExportOutlined />,
    title: 'Order V2',
  },
  // {
  //   key: URL_CARD_REQUEST,
  //   icon: <CreditCardOutlined />,
  //   title: 'Card Request',
  // },
  {
    key: URL_QUOTATIONS,
    icon: <FormOutlined />,
    title: 'Quotations',
  },
  {
    key: URL_RFQ,
    icon: <CalculatorOutlined />,
    title: 'RFQ',
  },
  {
    key: URLS.URL_RFQ_TO_SUPPLIER,
    icon: <MailOutlined />,
    title: 'RFQ To Supplier',
  },
  {
    key: URL_ENTITY,
    icon: <AuditOutlined />,
    title: 'Buyer Directory',
  },
  {
    key: URL_BUYER_INVOICING,
    icon: <FileProtectOutlined />,
    title: 'Buyer Invoicing',
  },
  {
    key: URL_SUPPLIERS,
    icon: <AuditOutlined />,
    title: 'Supplier Directory',
  },
  {
    key: URL_SUPPLIER_SOA,
    icon: <AuditOutlined />,
    title: 'Supplier SoA',
  },
  {
    key: URL_CUSTOMER_SOA,
    icon: <EuroCircleOutlined />,
    title: 'Customer SoA',
  },
  {
    key: URL_SOA_PAYMENTS,
    icon: <DollarOutlined />,
    title: 'SoA Payments',
  },
  {
    key: URL_CUSTOMER_SOA_CONSOLIDATED_LIST,
    icon: <DollarOutlined />,
    title: 'Customer SoA Payments',
  },
  {
    key: URL_SUPPLIER_PAYMENTS,
    icon: <MoneyCollectOutlined />,
    title: 'Supplier Payments',
  },
  {
    key: URL_PAYMENT_METHODS,
    icon: <RestOutlined />,
    title: 'Payment Methods',
  },
  {
    key: URL_SUPPLIER_PAYMENTS_V2,
    icon: <MoneyCollectOutlined />,
    title: 'Supplier Payments V2',
  },
  {
    key: URL_REVERT_SUPPLIER_PAYMENT_STATUS,
    icon: <UndoOutlined />,
    title: 'Revert Supplier Payments Status',
  },
  {
    key: URL_BILLING_PARTIES,
    icon: <BankOutlined />,
    title: 'Billing Parties',
  },
  {
    key: URLS.URL_OUTBOUND_EMAILS,
    icon: <MailOutlined />,
    title: 'Outbound Email',
  },
  {
    key: URL_EMAIL_READER_ORDER_FROM_MAIL,
    icon: <MailOutlined />,
    title: 'Email Reader',
  },
  {
    key: URL_PRODUCT_CODE,
    icon: <MonitorOutlined />,
    title: 'UNSPSC Code',
  },
  {
    key: URL_OCI,
    icon: <CiOutlined />,
    title: 'OCI Test',
  },
  {
    key: URL_RESOURCE,
    icon: <GlobalOutlined />,
    title: 'Product Resource',
  },
  {
    key: URL_RESOURCE_STORE,
    icon: <ShopOutlined />,
    title: 'Store',
  },
  {
    key: 'settings-submenu',
    icon: <SettingOutlined />,
    title: 'Settings',
    children: [
      {
        key: URL_SETTINGS,
        icon: <SettingOutlined />,
        title: 'General Setting',
      },
      {
        key: URL_EXCHANGE_RATE_SETTINGS,
        icon: <DollarOutlined />,
        title: 'Exchange Rate',
      },
      { key: URL_API_KEYS, icon: <KeyOutlined />, title: 'API Key' },
      {
        key: URL_PERMISSION_GROUPS,
        icon: <TeamOutlined />,
        title: 'Permission Groups',
      },
      {
        key: URL_API_KEY_ANALYTICS,
        icon: <PieChartOutlined />,
        title: 'API Key Analytics',
      },
    ],
  },
  {
    key: URL_CRON_TRIGGERS,
    icon: <ThunderboltOutlined />,
    title: 'Cron Triggers',
  },
  {
    key: URL_NOTIFICATIONS,
    icon: <BellOutlined />,
    title: 'Notifications',
  },
  {
    key: URL_SYNC_99SME,
    icon: <RetweetOutlined />,
    title: 'Sync To 99Sme',
  },
  {
    key: URL_JD_INTEGRATION,
    icon: <SwapOutlined />,
    title: 'JD Integration',
  },
  {
    key: URL_USERS,
    icon: <TeamOutlined />,
    title: 'Users',
  },
  {
    key: URL_XERO_SETTINGS,
    icon: <SettingOutlined />,
    title: 'Xero',
  },
  {
    key: URL_DELETE_PRODUCT,
    icon: <MinusCircleOutlined />,
    title: 'Delete Product',
  },
  {
    key: URL_GRN_RATING_LIST,
    icon: <StarFilled />,
    title: 'GRN Ratings',
  },
  {
    key: URLS.URL_AMAZON_ORDERS,
    icon: <AmazonOutlined />,
    title: 'Amazon Orders',
  },
  {
    key: URLS.URL_GOODS_DELIVERY,
    icon: <CarFilled />,
    title: 'Goods Delivery',
  },
  {
    key: URLS.URL_CONTRACT_LIST,
    icon: <FileProtectOutlined />,
    title: 'Contract Analyzer',
  },
];

// all menus
// then filtered according to user role
export const getMenuByRole = (menus, user) => {
  const allowedMenus = getAllowedURLS(user.role, user.team);
  return menus.reduce((acc, men) => {
    if (men.children) {
      const filteredChildren = men.children.filter(child =>
        allowedMenus.includes(child.key)
      );
      if (filteredChildren.length > 0) {
        acc.push({ ...men, children: filteredChildren });
      }
    } else if (allowedMenus.includes(men.key)) {
      acc.push(men);
    }
    return acc;
  }, []);
};

export const getAllowedURLS = (role, team) => {
  const allURLS = Object.values(URLS);
  const onlySuperadmin = [
    URL_DELETE_PRODUCT,
    URL_REVERT_SUPPLIER_PAYMENT_STATUS,
    URL_CRON_TRIGGERS,
  ];

  if (role === USER_ROLES.superadmin) {
    return allURLS;
  } else if (!![USER_ROLES.member, USER_ROLES.staff].includes(role)) {
    return allURLS.filter(url => {
      // Quotations and RFQ
      if (url === URL_QUOTATIONS || url === URL_RFQ) {
        // return [
        //   USER_TEAMS.FINANCE,
        //   USER_TEAMS.FINANCE_EXCLUSIVE,
        //   USER_TEAMS.OPERATIONS,
        // ].includes(team);
        return false;
      }

      const notSuperAdmin = !onlySuperadmin.includes(url);

      return notSuperAdmin;
    });
  }

  let allowedMenus = [URL_PRODUCT_EXTERNAL, URLS.URL_PRODUCT_EXTERNAL_LISTING];

  if (role === USER_ROLES.om) {
    allowedMenus = [
      URL_PRODUCT,
      URL_SUPPLIERS,
      URL_SUPPLIER_PAYMENTS,
      URL_PAYMENT_METHODS,
      URL_SUPPLIER_PAYMENTS_V2,
      URL_SUPPLIER_PAYMENTS_GRAPHS,
      URL_LINE_ITEM_ANALYTIC,
      URL_ANALYTICS,
    ];
  } else if (role === USER_ROLES.am) {
    // Based on task SME-2602
    // allowedMenus = [URL_HOME, URL_PO, URL_QUOTATIONS, URL_RFQ, URL_ENTITY];
    // return allURLS
    return allURLS.filter(u => u !== URL_REVERT_SUPPLIER_PAYMENT_STATUS);
  } else if (role === USER_ROLES.both) {
    allowedMenus = [
      URL_PRODUCT,
      URL_ASYNC_TASK_REPORT,
      URL_PO,
      URL_PO_V2,
      // URL_QUOTATIONS,
      // URL_RFQ,
      URL_ENTITY,
      URL_SUPPLIERS,
      URL_SUPPLIER_PAYMENTS,
      URL_PAYMENT_METHODS,
      URL_SUPPLIER_PAYMENTS_V2,
      URL_SUPPLIER_PAYMENTS_GRAPHS,
      URL_LINE_ITEM_ANALYTIC,
      URL_ANALYTICS,
      URL_MONTHLY_ANALYTICS,
    ];
  } else if (role === USER_ROLES.agent) {
    allowedMenus = [URL_PRODUCT, URL_PO, URL_PO_V2];
  } else if (role === USER_ROLES.member) {
    allowedMenus = [
      URL_PRODUCT,
      // URL_QUOTATIONS,
      URL_SUPPLIER_PAYMENTS,
      URL_SUPPLIER_PAYMENTS_V2,
      URL_SUPPLIER_PAYMENTS_GRAPHS,
      URL_LINE_ITEM_ANALYTIC,
      URL_ANALYTICS,
      URL_PRODUCT_CODE,
      URL_OCI,
      URL_RESOURCE,
    ];
  } else if (role === USER_ROLES.external) {
    allowedMenus = [URL_PRODUCT];
  }

  if (team === USER_TEAMS.FINANCE) {
    allowedMenus.push(URL_XERO_SETTINGS);
  }

  // if (!!user.can_gen_vcard) {
  //   items.splice(3, 0, {
  //     key: URL_CARD_REQUEST,
  //     icon: <CreditCardOutlined />,
  //     title: 'Card Request',
  //   });
  // }

  return allowedMenus;
};

const DashboardLayout = (props: Props) => {
  const location = useLocation();
  const { user, cartVisible } = useSelector((state: AppState) => ({
    cartVisible: state.cart.visible,
    user: state.user,
  }));
  const { data: menuConfig } = useQuery(
    ['menu_config'],
    () => fetchAPI('product/constants/menu_config'),
    {
      staleTime: Infinity,
      placeholderData: {},
    }
  );

  const sortedMenuItems = React.useMemo(() => {
    if (!menuConfig || !menuConfig.items) {
      return menuItems;
    }

    const configItems: any[] = menuConfig.items || [];
    const configMap = new Map(configItems.map(item => [item.key, item]));

    const processedItems = menuItems.map((item, index) => {
      const config: any = configMap.get(item.key);
      return {
        ...item,
        visible: config ? config.visible : true,
        order: config ? config.order : index,
      };
    });

    return processedItems
      .filter(item => item.visible)
      .sort((a, b) => a.order - b.order);
  }, [menuConfig]);

  const filteredMenu = getMenuByRole(sortedMenuItems, user);
  // note: pattern URLs (`:id`/`:companyId`) need prefix-match; bare paths stay exact.
  // Also: invoice detail page is explicitly open to every logged-in role per product spec,
  // so it bypasses the role allowlist check (URL_ORDER_INVOICE_DETAIL is only in
  // superadmin/member/staff/om/both allowlists — `agent`/`external` etc. don't list it).
  const allowed =
    !!getAllowedURLS(user.role, user.team).find(urlPath => {
      if (urlPath.includes(':'))
        return location.pathname.startsWith(urlPath.split(':')[0]);
      return urlPath === location.pathname;
    }) || /^\/order-invoice\/\d+$/.test(location.pathname);
  const { isSmallScreen } = useWindowDimension();
  const defaultOpenKeys =
    location.pathname === URL_ANALYTICS ||
    location.pathname.startsWith(URL_SUPPLIER_PAYMENTS_GRAPHS)
      ? ['analytic-submenu']
      : [];

  const renderMenu = () => {
    const renderMenuItem = (item: any) => {
      if (item.children) {
        return (
          <Menu.SubMenu key={item.key} icon={item.icon} title={item.title}>
            {item.children.map((child: any) => (
              <Menu.Item key={child.key}>
                <Link to={child.key}>
                  {child.icon}
                  <span>{child.title}</span>
                </Link>
              </Menu.Item>
            ))}
          </Menu.SubMenu>
        );
      }
      return (
        <Menu.Item key={item.key}>
          <Link to={item.key}>
            {item.icon}
            <span>{item.title}</span>
          </Link>
        </Menu.Item>
      );
    };

    return (
      <MenuWrapper>
        <Menu
          theme="dark"
          selectedKeys={[location.pathname]}
          defaultOpenKeys={defaultOpenKeys}
          mode={isSmallScreen ? 'horizontal' : 'inline'}
        >
          {filteredMenu.map(item => renderMenuItem(item))}
        </Menu>
      </MenuWrapper>
    );
  };

  return (
    <Layout>
      {!isSmallScreen && (
        <Sider collapsible width={200}>
          <StyledDivImg>
            <Link to="/">
              <img style={{ height: 32 }} src={LOGO} alt="main-logo" />
            </Link>
          </StyledDivImg>
          {renderMenu()}
        </Sider>
      )}

      <StyledContentLayout>
        {isSmallScreen && <div>{renderMenu()}</div>}

        <DashboardHeader />
        {cartVisible && <CartDrawer />}
        <Content style={{ padding: 20, overflowY: 'auto' }}>
          {allowed ? props.children : <Page403 />}
        </Content>
      </StyledContentLayout>
    </Layout>
  );
};

const StyledContentLayout = styled(Layout)`
  /* height: 100vh;
  overflow: hidden; */
  .ant-select-arrow {
    // margin-top: -20px;
  }
`;

const MenuWrapper = styled.div`
  .ant-menu-dark {
    @media (min-width: 768px) {
      overflow-y: scroll !important;
      height: 100vh !important;
      padding-bottom: 200px !important;
    }

    &::-webkit-scrollbar {
      width: 7px;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: none;
      background: #d8e0ec;
    }

    &::-webkit-scrollbar-thumb {
      background: #aab0b8;
      border-radius: 0px;
      // outline: solid 1px #111;
      border: none;
    }
  }
`;

const StyledDivImg = styled.div`
  margin-bottom: 10px;
  padding: 10px 5px 5px 5px;
  text-align: center;
  background-color: #f1f1f1;
  height: 55px;
`;

export default DashboardLayout;
